import React, { useState } from "react";
import Field from "../components/Field";
import mockEmployee from "../data/mockEmployee";

export default function EmployeeProfile() {
  const [role, setRole] = useState("employee"); // employee or hr
  const [employee, setEmployee] = useState(mockEmployee);
  const [form, setForm] = useState({ ...employee });
  const [editing, setEditing] = useState(false);
  const [message, setMessage] = useState("");

  const hrOnly = ["salary", "bonuses", "notes"];

  const canViewField = (field) => {
    if (hrOnly.includes(field) && role !== "hr") return false;
    return true;
  };

  const employeeEditable = ["personalEmail", "phone", "emergencyContact"];
  const canEditField = (field) => {
    if (role === "hr") return true;
    return employeeEditable.includes(field);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    setEmployee({ ...form });
    setEditing(false);
    setMessage("Saved successfully.");
    setTimeout(() => setMessage(""), 2000);
  };

  const handleCancel = () => {
    setForm({ ...employee });
    setEditing(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto bg-white shadow-md rounded-2xl p-6">
        <header className="flex justify-between items-center mb-6">
          <h1 className="text-xl font-bold">Employee Profile</h1>

          <div className="flex items-center gap-3">
            <select
              value={role}
              onChange={(e) => setRole(e.target.value)}
              className="border rounded px-2 py-1"
            >
              <option value="employee">Employee</option>
              <option value="hr">HR</option>
            </select>

            <button
              onClick={() => {
                setEditing(true);
                setForm({ ...employee });
              }}
              className="bg-blue-600 text-white px-3 py-1 rounded-lg"
            >
              Edit
            </button>
          </div>
        </header>

        <section className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* LEFT SIDE */}
          <div className="space-y-3">
            <Field label="Employee ID" value={employee.id} editable={false} show />

            <Field
              label="Full Name"
              name="name"
              value={form.name}
              show={canViewField("name")}
              editable={editing && canEditField("name")}
              onChange={handleChange}
            />

            <Field
              label="Job Title"
              name="jobTitle"
              value={form.jobTitle}
              show
              editable={editing && canEditField("jobTitle")}
              onChange={handleChange}
            />

            <Field
              label="Department"
              name="department"
              value={form.department}
              show
              editable={editing && canEditField("department")}
              onChange={handleChange}
            />

            <Field label="Manager" value={employee.manager} show />
            <Field label="Hire Date" value={employee.hireDate} show />

            <Field
              label="Leave Balance"
              value={employee.leaveBalance + " days"}
              show
            />
          </div>

          {/* RIGHT SIDE */}
          <div className="space-y-3">
            <Field
              label="Work Email"
              name="workEmail"
              value={form.workEmail}
              show
              editable={editing && canEditField("workEmail")}
              onChange={handleChange}
            />

            <Field
              label="Personal Email"
              name="personalEmail"
              value={form.personalEmail}
              show
              editable={editing && canEditField("personalEmail")}
              onChange={handleChange}
            />

            <Field
              label="Phone"
              name="phone"
              value={form.phone}
              show
              editable={editing && canEditField("phone")}
              onChange={handleChange}
            />

            <Field
              label="Emergency Contact"
              name="emergencyContact"
              value={form.emergencyContact}
              show
              editable={editing && canEditField("emergencyContact")}
              onChange={handleChange}
            />

            {canViewField("salary") && (
              <Field
                label="Salary"
                name="salary"
                type="number"
                value={form.salary}
                editable={editing}
                onChange={handleChange}
              />
            )}

            {canViewField("bonuses") && (
              <Field
                label="Bonuses"
                name="bonuses"
                type="number"
                value={form.bonuses}
                editable={editing}
                onChange={handleChange}
              />
            )}

            {canViewField("notes") && (
              <Field
                label="HR Notes"
                name="notes"
                value={form.notes}
                editable={editing}
                onChange={handleChange}
                textarea
              />
            )}
          </div>
        </section>

        <footer className="mt-6 flex justify-between items-center">
          <div className="text-green-600 text-sm">{message}</div>

          {editing ? (
            <div className="space-x-2">
              <button
                onClick={handleSave}
                className="bg-green-600 text-white px-4 py-1 rounded-lg"
              >
                Save
              </button>
              <button
                onClick={handleCancel}
                className="bg-gray-200 px-4 py-1 rounded-lg"
              >
                Cancel
              </button>
            </div>
          ) : (
            <div className="text-sm text-gray-600">
              Viewing as <b>{role}</b>
            </div>
          )}
        </footer>
      </div>
    </div>
  );
}
